const initRadarChart = () => {
    const radarWidgetsList = document.querySelectorAll(".radar-widget");
    if (radarWidgetsList && radarWidgetsList.length > 0) {
        radarWidgetsList.forEach((radarWidget) => {
            infoRadarHoverFeature(radarWidget);
            drawRadarChartJS(radarWidget);
        });
    }
};
const drawRadarChartJS = (radarWidget) => {
    const featuresRadarContainer = radarWidget.querySelector(".features-radar-container");
    const productsNamesList = radarWidget.querySelectorAll("[data-product-name]");
    const datasContainerList = featuresRadarContainer.querySelectorAll(".datas-container");
    const dataFeatureNameArray = [];
    const productsNamesArray = [];
    const opponentDataProductFeatureValueArray = [];
    const companyDataProductFeatureValueArray = [];
    productsNamesList.forEach((productName) => {
        const dataproductName = productName.getAttribute("data-product-name");
        productsNamesArray.push(dataproductName);
    });
    datasContainerList.forEach((datasContainer) => {
        const dataFeatureName = datasContainer.querySelector("[data-feature-name]").getAttribute("data-feature-name");
        const dataProductFeatureId = datasContainer.querySelector("[data-product-feature-id]").getAttribute("data-product-feature-id");
        const dataProductFeatureValueList = datasContainer.querySelectorAll("[data-company]");
        dataFeatureNameArray.push(`${dataFeatureName}`);
        productsNamesArray.push(dataProductFeatureId);
        dataProductFeatureValueList.forEach((dataProductFeatureValue) => {
            if (dataProductFeatureValue.getAttribute("data-company") == "company-product") {
                companyDataProductFeatureValueArray.push(dataProductFeatureValue.getAttribute("data-product-feature-value"));
            }
            else if (dataProductFeatureValue.getAttribute("data-company") == "opponent-product") {
                opponentDataProductFeatureValueArray.push(dataProductFeatureValue.getAttribute("data-product-feature-value"));
            }
        });
    });
    const labels = [
        dataFeatureNameArray
    ];
    const data = {
        labels: labels[0],
        datasets: [{
                data: [100, 100, 100, 100, 100, 100, 100, 100],
                fill: false,
                borderColor: 'rgba(255, 255, 255, 0)',
                pointRadius: 8,
                pointHoverRadius: 8,
                pointBackgroundColor: '#CCCCCC',
                pointBorderColor: '#CCCCCC',
                pointHoverBackgroundColor: '#00AED7',
                pointHoverBorderColor: '#00AED7'
            }, {
                label: productsNamesArray[0],
                data: companyDataProductFeatureValueArray,
                fill: true,
                backgroundColor: 'rgba(0, 174, 215, 0.15)',
                borderColor: '#00AED7',
                borderWidth: 4,
                pointRadius: 0,
            }, {
                label: productsNamesArray[1],
                data: opponentDataProductFeatureValueArray,
                fill: true,
                backgroundColor: 'rgba(204, 204, 204, 0.75)',
                borderColor: 'rgba(204, 204, 204, 0.75)',
                borderWidth: 1,
                pointRadius: 0
            }]
    };
    const options = {
        responsive: true,
        onHover: (event, chartElement) => {
            if (chartElement.length == 1) {
                event.native.target.style.cursor = chartElement[0] ? "pointer" : "default";
            }
        },
        scales: {
            r: {
                grid: {
                    circular: true,
                    color: ["#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#CCCCCC", "#999999"],
                    lineWidth: [1, 1, 1, 1, 1, 1, 1, 1, 1, 2],
                },
                pointLabels: {
                    font: function (ctx) {
                        const viewportWidth = ctx.chart.width;
                        if (viewportWidth <= 400) {
                            return {
                                family: "Helvetica, sans-serif",
                                size: 8,
                                weight: "normal"
                            };
                        }
                        else {
                            return {
                                family: "Helvetica, sans-serif",
                                size: 14,
                                weight: "normal"
                            };
                        }
                    },
                    padding: 15,
                    color: "#000"
                },
                ticks: {
                    display: false
                },
                beginAtZero: true
            }
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            }
        },
    };
    const config = {
        type: "radar",
        data: data,
        options: options
    };
    const radar = document.querySelector("#productChart");
    const context = radar.getContext("2d");
    const myChart = new Chart(context, config);
};
const infoRadarHoverFeature = (radarWidget) => {
    const featureProductsArray = radarWidget.querySelectorAll(".feature-product");
    if (featureProductsArray && featureProductsArray.length > 0) {
        featureProductsArray.forEach((featureProduct) => {
            const featureName = featureProduct.querySelector(".feature-name");
            featureName.addEventListener("mouseover", () => {
                const numericValue = featureProduct.querySelector(".numeric-value");
                const textValue = featureProduct.querySelector(".text-value");
                if (numericValue && textValue) {
                    featureName.classList.add("hover");
                    numericValue.classList.add("hover");
                    textValue.classList.add("hover");
                }
            });
            featureName.addEventListener("mouseleave", () => {
                const numericValue = featureProduct.querySelector(".numeric-value");
                const textValue = featureProduct.querySelector(".text-value");
                if (numericValue && textValue) {
                    featureName.classList.remove("hover");
                    numericValue.classList.remove("hover");
                    textValue.classList.remove("hover");
                }
            });
        });
    }
};
